module.exports = __webpack_public_path__ + "img/Boss-3.5ba49965.gif";